import React from "react";
import { Link } from "react-router-dom";

export const SizeGuide = () => {
  return (
    <div className="min-h-screen pt-20 bg-white">
      {/* Main Content */}
      <section className="py-32 md:py-40 px-6">
        <div className="max-w-4xl mx-auto">
          {/* Heading */}
          <h1 
            className="text-4xl md:text-5xl mb-20 font-light tracking-wide text-center" 
            style={{ fontFamily: "'Playfair Display', serif", fontWeight: 300 }}
          >
            Size Guide
          </h1>

          {/* MIA Woman Section */}
          <div className="mb-24">
            <h2 
              className="text-2xl md:text-3xl mb-12 font-light tracking-wide text-center" 
              style={{ fontFamily: "'Playfair Display', serif", fontWeight: 300 }}
            >
              MIA Woman
            </h2>

            {/* Size Table */}
            <div className="overflow-x-auto mb-8">
              <table className="w-full">
                <thead>
                  <tr className="border-b border-[#E8DCC8]">
                    <th className="text-left py-4 text-sm font-light tracking-wide" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                      Size
                    </th>
                    <th className="text-center py-4 text-sm font-light tracking-wide" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                      UK
                    </th>
                    <th className="text-center py-4 text-sm font-light tracking-wide" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                      US
                    </th>
                    <th className="text-center py-4 text-sm font-light tracking-wide" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                      Bust (cm)
                    </th>
                    <th className="text-center py-4 text-sm font-light tracking-wide" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                      Waist (cm)
                    </th>
                    <th className="text-center py-4 text-sm font-light tracking-wide" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                      Hip (cm)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { size: "XS", uk: "6", us: "2", bust: "81-84", waist: "63-66", hip: "89-92" },
                    { size: "S", uk: "8", us: "4", bust: "86-89", waist: "68-71", hip: "94-97" },
                    { size: "M", uk: "10", us: "6", bust: "91-94", waist: "73-76", hip: "99-102" },
                    { size: "L", uk: "12", us: "8", bust: "96-99", waist: "78-81", hip: "104-107" },
                    { size: "XL", uk: "14", us: "10", bust: "101-104", waist: "83-86", hip: "109-112" }
                  ].map((row, index) => (
                    <tr key={index} className="border-b border-[#E8DCC8]/30">
                      <td className="py-4 text-sm font-light text-[#2C2C2C]" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                        {row.size}
                      </td>
                      <td className="text-center py-4 text-sm font-light text-[#2C2C2C]" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                        {row.uk}
                      </td>
                      <td className="text-center py-4 text-sm font-light text-[#2C2C2C]" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                        {row.us}
                      </td>
                      <td className="text-center py-4 text-sm font-light text-[#2C2C2C]" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                        {row.bust}
                      </td>
                      <td className="text-center py-4 text-sm font-light text-[#2C2C2C]" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                        {row.waist}
                      </td>
                      <td className="text-center py-4 text-sm font-light text-[#2C2C2C]" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                        {row.hip}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Fit Guidance */}
            <div className="space-y-4">
              <p className="text-sm text-[#8B7D6B] font-light leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                Fit may vary depending on silhouette. Structured pieces are tailored for a closer fit, while relaxed styles offer more ease.
              </p>
              <p className="text-sm text-[#8B7D6B] font-light leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                If you are between sizes, we recommend reviewing the product description for fit notes.
              </p>
            </div>
          </div>

          {/* MIA Girl Section */}
          <div className="mb-24">
            <h2 
              className="text-2xl md:text-3xl mb-12 font-light tracking-wide text-center" 
              style={{ fontFamily: "'Playfair Display', serif", fontWeight: 300 }}
            >
              MIA Girl
            </h2>

            {/* Size Table */}
            <div className="overflow-x-auto mb-8">
              <table className="w-full">
                <thead>
                  <tr className="border-b border-[#E8DCC8]">
                    <th className="text-left py-4 text-sm font-light tracking-wide" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                      Size
                    </th>
                    <th className="text-center py-4 text-sm font-light tracking-wide" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                      Age
                    </th>
                    <th className="text-center py-4 text-sm font-light tracking-wide" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                      Height (cm)
                    </th>
                    <th className="text-center py-4 text-sm font-light tracking-wide" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                      Chest (cm)
                    </th>
                    <th className="text-center py-4 text-sm font-light tracking-wide" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                      Waist (cm)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { size: "4Y", age: "4", height: "104", chest: "56", waist: "53" },
                    { size: "6Y", age: "6", height: "116", chest: "60", waist: "56" },
                    { size: "8Y", age: "8", height: "128", chest: "64", waist: "58" },
                    { size: "10Y", age: "10", height: "140", chest: "70", waist: "61" },
                    { size: "12Y", age: "12", height: "152", chest: "76", waist: "64" }
                  ].map((row, index) => (
                    <tr key={index} className="border-b border-[#E8DCC8]/30">
                      <td className="py-4 text-sm font-light text-[#2C2C2C]" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                        {row.size}
                      </td>
                      <td className="text-center py-4 text-sm font-light text-[#2C2C2C]" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                        {row.age}
                      </td>
                      <td className="text-center py-4 text-sm font-light text-[#2C2C2C]" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                        {row.height}
                      </td>
                      <td className="text-center py-4 text-sm font-light text-[#2C2C2C]" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                        {row.chest}
                      </td>
                      <td className="text-center py-4 text-sm font-light text-[#2C2C2C]" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                        {row.waist}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Fit Guidance */}
            <div className="space-y-4">
              <p className="text-sm text-[#8B7D6B] font-light leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                MIA Girl pieces are designed to allow room for growth.
              </p>
              <p className="text-sm text-[#8B7D6B] font-light leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                Age ranges are approximate and may vary by individual.
              </p>
            </div>
          </div>

          {/* Return Clarification */}
          <div className="pt-16 text-center border-t border-[#E8DCC8]/30">
            <p className="text-xs text-[#A39383] font-light leading-relaxed mb-3" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
              Returns accepted for sizing issues only within 7 days of delivery.
            </p>
            <p className="text-xs text-[#A39383] font-light leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
              For full details, please refer to our{" "}
              <Link to="/shipping-returns" className="underline hover:text-[#2C2C2C] transition-colors">
                Shipping & Returns
              </Link>{" "}
              policy.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};
